import React from 'react'
import Layout from '../../components/Layout'
import BookingApproval from '../../components/admin/BookingApproval'

const BookingApprovalPage: React.FC = () => {
  return (
    <Layout>
      <BookingApproval />
    </Layout>
  )
}

export default BookingApprovalPage